import _is from "ramda/es/is";
import _when from "ramda/es/when";
import _pipe from "ramda/es/pipe";
import stringify from 'json-stringify-safe';
import { serializeError } from 'serialize-error';
export default (function (title) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return _pipe(_when(_is(Error), serializeError), stringify, function (s) {
    return console.log("".concat(title).concat(data ? ": ".concat(s) : ''));
  } // eslint-disable-line no-console
  )(data);
});